import React from "react";
import BillingOverviewIcon from "../../assets/icons/billing_overview.svg2";
import InboundNumbersIcon from "../../assets/icons/inbound_numbers.svg2";
import PaymentMethodsIcon from "../../assets/icons/payment_methods.svg2";
import InvoicingIcon from "../../assets/icons/invoicing.svg2";
import SettingsIcon from "../../assets/icons/settings.svg2";
import InvoicingHistoryIcon from "../../assets/icons/invoice_history.svg2";
import PageNavLinks from "../Common/PageNavLinks";

export default function BillingLinks() {
  return (
    <PageNavLinks
      pageName="billing"
      links={[
        {
          label: "STATUS",
          Icon: SettingsIcon,
          href: "/billing/status",
        },
        {
          label: "OVERVIEW",
          Icon: BillingOverviewIcon,
          href: "/billing/overview",
        },
        {
          label: "INBOUND NUMBERS",
          Icon: InboundNumbersIcon,
          href: "/billing/inbounds",
        },
        {
          label: "PAYMENT METHODS",
          Icon: PaymentMethodsIcon,
          href: "/billing/payment",
        },
        {
          label: "BILLING DETAILS",
          Icon: InvoicingIcon,
          href: "/billing/details",
        },
        {
          label: "INVOICES",
          Icon: InvoicingHistoryIcon,
          href: "/billing/invoices",
          badge: "2",
        },
      ]}
    />
  );
}
